module.exports = __webpack_public_path__ + "img/Copy.e54e1634.svg";